import React, { useState } from 'react'
import NotifTerapisPage from './notifications/NotifTerapisPage'
import NotifCleanerPage from './notifications/NotifCleanerPage'
import NotifUserPage from './notifications/NotifUserPage' // [1. TAMBAHAN IMPORT]
import NotifDriverMotorPage from './notifications/NotifDriverMotorPage'
import NotifDriverMobilPage from './notifications/NotifDriverMobilPage'

/**
 * NotificationPage (Dashboard Zimo Admin)
 * - Menampilkan kategori notifikasi untuk berbagai jenis pengguna
 * - Klik "Notifikasi Terapis", "Cleaner", atau "User" akan membuka halaman pengiriman
 */

export default function NotificationPage() {
  const [activePage, setActivePage] = useState('main')

  // 🔹 Daftar kategori notifikasi
  const notifCategories = [
    {
      title: 'Notifikasi User',
      desc: 'Kirim pengumuman atau informasi kepada seluruh pengguna aplikasi.',
      count: 8,
    },
    {
      title: 'Notifikasi Driver Motor',
      desc: 'Kirim pemberitahuan ke pengemudi motor Zimo Delivery.',
      count: 3,
    },
    {
      title: 'Notifikasi Driver Mobil',
      desc: 'Kirim informasi atau pengingat ke pengemudi mobil Zimo.',
      count: 1,
    },
    {
      title: 'Notifikasi Terapis',
      desc: 'Kirim pengumuman atau informasi terkait layanan terapis.',
      count: 6,
    },
    {
      title: 'Notifikasi Cleaner',
      desc: 'Kirim pemberitahuan kepada tim cleaner di seluruh area.',
      count: 2,
    },
    {
      title: 'Notifikasi Langsung ke Nama',
      desc: 'Kirim pesan khusus ke pengguna, mitra, atau driver tertentu.',
      count: 0,
    },
  ]

  // [2. TAMBAHAN LOGIKA RENDER HALAMAN]
  if (activePage === 'user') {
    return <NotifUserPage onBack={() => setActivePage('main')} />
  }

  if (activePage === 'terapis') {
    return <NotifTerapisPage onBack={() => setActivePage('main')} />
  }

  if (activePage === 'cleaner') {
    return <NotifCleanerPage setActiveMenu={setActivePage} />
  }
  
  // --- TAMBAHAN KODE: Arahkan ke halaman Driver ---
  if (activePage === 'driver_motor') {
    return <NotifDriverMotorPage onBack={() => setActivePage('main')} />
  }

  if (activePage === 'driver_mobil') {
    return <NotifDriverMobilPage onBack={() => setActivePage('main')} />
  }

  // 🔹 Halaman utama daftar kategori
  return (
    <div className="space-y-6 text-gray-300">
      {/* HEADER NOTIFIKASI */}
      <div>
        <h2 className="text-xl font-semibold text-white mb-1">
          Manajemen Notifikasi
        </h2>
        <p className="text-sm text-gray-400">
          Pilih kategori notifikasi untuk mengirim atau mengelola pemberitahuan.
        </p>
      </div>

      {/* LIST KATEGORI */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {notifCategories.map((item, idx) => (
          <div
            key={idx}
            onClick={() => {
              // [3. TAMBAHAN LOGIKA KLIK]
              if (item.title === 'Notifikasi User') setActivePage('user') 
              if (item.title === 'Notifikasi Terapis') setActivePage('terapis')
              if (item.title === 'Notifikasi Cleaner') setActivePage('cleaner')
              // --- TAMBAHAN KODE: Routing untuk Driver ---
              if (item.title === 'Notifikasi Driver Motor') setActivePage('driver_motor')
              if (item.title === 'Notifikasi Driver Mobil') setActivePage('driver_mobil')
            }}
            className="relative bg-gray-900 border border-gray-700 rounded-xl p-4 hover:bg-gray-800 hover:shadow-lg transition cursor-pointer"
          >
            {/* Jumlah notifikasi baru */}
            {item.count > 0 && (
              <span className="absolute top-3 right-4 bg-blue-600 text-white text-xs font-semibold px-2 py-0.5 rounded-full">
                {item.count}
              </span>
            )}
            <h3 className="font-semibold text-white mb-1">{item.title}</h3>
            <p className="text-sm text-gray-400">{item.desc}</p>
          </div>
        ))}
      </div>

      {/* FOOTER INFO */}
      <div className="text-xs text-gray-500 border-t border-gray-700 pt-4">
        *Setiap notifikasi akan tersimpan otomatis di Firestore (koleksi
        <code className="mx-1 text-blue-400">notifications</code> atau sub-koleksi user) 
        dan dapat diterima langsung oleh pengguna atau mitra melalui aplikasi Zimo.
      </div>
    </div>
  )
}